import React, {useState, useEffect} from 'react';
import SimpleBar from 'simplebar-react';
import TaxonomyModal from '../TaxonomyModal';

function FilterContainer(props) {
  const {
    className,
    label,
    labelTitle,
    selected,
    taxSlug,
    scrollable,
    collapsible,
    listLabel,
    taxModal,
    modalTitle,
    modalContent
  } = props;
 
  const collapseClass = collapsible ? 'collapsible' : '';
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  let content;
  let labelcontent;
  let listLabelElement;
  let modalElement;
  let modalContainer;

  function countClass() {
    let classString = '';

    if (count > 0) {
      classString = 'count-visible ';
    }

    if (taxModal) {
      classString += 'has-modal';
    }

    return classString;
  }

  function updateCount() {
    if (selected && taxSlug && selected.hasOwnProperty(taxSlug)) {
      setCount(selected[taxSlug].length);
    }
  }

  function toggleOpen() {
    if (collapsible) {
      setOpen(!open);
    }
  }

  function toggleClass() {
    let classString = '';

    if (open) {
      classString = 'open';
    }

    return classString;
  }

  if (scrollable) {
    content = <SimpleBar>{props.children}</SimpleBar>
  }
  else {
    content = props.children;
  }

  if (listLabel) {
    listLabelElement = <span className="label-info d-lg-none">({listLabel})</span>
  }

  if (taxModal) {
    modalElement = <div className="filter-modal">
        <span className="filter-modal-trigger" onClick={() => openModal()}></span>
        <TaxonomyModal
          title = {modalTitle}
          icons = {modalContent}
        ></TaxonomyModal>
      </div>
  }


  if (labelTitle) {
    labelcontent = <h6 onClick={() => toggleOpen()} className={countClass()} data-count={count}>
      <span>{labelTitle}</span>
      {listLabelElement}
    </h6>
  }

   useEffect(() => {
    updateCount();
  }, [selected]);

  function openModal() {
    const modalWrapper = document.querySelector('.taxonomy-modal');

    if (modalWrapper) {
      modalWrapper.classList.toggle('taxonomy-modal--active');
      document.body.style.overflow = 'hidden';
    }
  }

  return(
    <div className={`eight29-filter ${className}`}>
      <div className={`accordion-select ${toggleClass()} ${collapseClass}`}>
        <div className="filter-dropdown-main-wrapper">
          {labelcontent}
          {modalElement}
          {content}
        </div>
      </div>
    </div>
  )
}

export default FilterContainer;